import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { color, iconUrl } from '../styles/vars'
import { fbShareParselyTrackLink, getFbShareUrl } from '../utils';

export const FB_ICON_CLASS_NAME = 'fbIcon';

class FbShare extends React.Component {
	constructor(props){
		super(props);
	}

	render(){
		return (
			<a href={getFbShareUrl(this.props.url)}
			   data-url-to-track={this.props.url}
			   target="_blank"
			   onClick={fbShareParselyTrackLink}
			>
				<span className={css(styles.fbIcon)}></span>
			</a>
		);
	}

}

export default FbShare;

const styles = StyleSheet.create({
	[FB_ICON_CLASS_NAME]: {
		display: 'inline-block',
		width: '59px',
		height: '20px',
		background: `url(${iconUrl.facebookShare})`,
		backgroundSize: '100%'
	}
});



// WEBPACK FOOTER //
// ./react-app-src/shared/components/FbShare.js